var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98042 3.072C8.98144 3.89083 7.63602 4.57402 6 4.57402C4.36398 4.57402 3.01856 3.89083 2.01958 3.072C1.0262 2.25775 0.338931 1.28122 0 0.603363L1.20672 1.07222e-07C1.46742 0.521391 2.03936 1.34374 2.87485 2.02857C3.70473 2.7088 4.75781 3.22486 6 3.22486C7.24219 3.22486 8.29527 2.7088 9.12515 2.02857C9.96064 1.34374 10.5326 0.521391 10.7933 0L12 0.603363C11.6611 1.28122 10.9738 2.25775 9.98042 3.072Z",
    fill: "#0C4284"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49003 6.59779L5.49003 3.89948L6.83919 3.89948L6.83919 6.59779L5.49003 6.59779Z",
    fill: "#0C4284"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0322 5.57635L8.73949 3.3373L9.9079 2.66272L11.2006 4.90177L10.0322 5.57635Z",
    fill: "#0C4284"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30307 3.4701L2.08702 5.57637L0.91861 4.90179L2.13467 2.79552L3.30307 3.4701Z",
    fill: "#0C4284"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/close-eye.8c8c8ccc4f901bdd3a4a16574b12047b.svg";
export { ForwardRef as ReactComponent };